import React from 'react';
import { ShippingAddressInfoBlock } from '../ShippingAddressInfoBlock/ShippingAddressInfoBlock';
import { RestAddressAttributesData } from '../../../hooks/useAddress';
import { CheckoutSectionSummary } from '../../CheckoutSection';

interface Props {
  attributes: RestAddressAttributesData | undefined;
  onSwitch: () => void;
}

export const ShippingAddressPreview: React.FC<Props> = ({ attributes, onSwitch }) =>
  attributes ? (
    <CheckoutSectionSummary onChange={onSwitch}>
      <ShippingAddressInfoBlock data={attributes} />
    </CheckoutSectionSummary>
  ) : null;
